<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $tc("message.mobile.etablissement", 2) }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <b-container>
            <b-row>
              <b-col col sm="12">
                <vue-good-table
                  id="operation"
                  :columns="comptableColumns"
                  :rows="comptableRows"
                  :search-options="{
                    enabled: true,
                  }"
                  :pagination-options="paginationOptions"
                />
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "Accountants",
  computed: {
    ...mapGetters([
      "file",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasAssistante",
      "hasPatientRole",
      "hasPraticienRole",
      "hasSouscripteurRole",
      "hasGestionnaireRole",
      "etablissements",
    ]),

    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.hasAssistante
      );
    },

    comptableColumns: function () {
      return [
        {
          label: this.$i18n.tc("message.name"),
          field: "name",
        },
        {
          label: this.$i18n.tc("message.telephone"),
          field: "phone",
        },
        {
          label: this.$i18n.tc("message.email"),
          field: "email",
        },

        {
          label: this.$i18n.tc("message.countries"),
          field: "pays",
        },
        {
          label: this.$i18n.tc("message.city"),
          field: "ville",
        },

        {
          label: this.$i18n.tc("message.specialty"),
          field: "specialty",
        },
      ];
    },

    comptableRows: function () {
      let cArray = [];

      _.forEach(this.etablissements, function (etablissement) {
        if (!_.isNull(etablissement)) {
          cArray.push({
            name: etablissement.name,
            phone: etablissement.code + etablissement.phone,
            email: etablissement.email,

            pays: etablissement.localisation.pays,
            ville: etablissement.localisation.ville,
            specialty: etablissement.specialites_etablissement
              .map((specialite) => specialite.libelle)
              .join(","),
          });
        }
      });
      return cArray;
    },
  },
  data() {
    return {
      paginationOptions: {
        enabled: true,
        mode: "records",
        perPageDropdown: [3, 6, 10],
      },
    };
  },
  methods: {
    getEtablissements() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getEtablissements", { args: args });
    },

    onComptableClick(params) {
      this.$router.push({
        name: "accountant",
        params: { accountant: params.row.slug },
      });
    },
  },
  mounted() {
    this.getEtablissements();
  },
};
</script>

<style scoped></style>
